module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"r-delete":"Удалить","r-delete:info":"Объект будет удален безвозвратно","r-delete:question":"Удалить объект?"},"en":{"r-delete":"Delete","r-delete:info":"The object will be permanently deleted","r-delete:question":"Delete object?"}}')
  delete Component.options._Ctor
}
